<section class="hero" (window:resize)="onResize($event)">
    <div class="hero-inner">
        <div class="container">
            <div class="row">
                <div class="col-xs-12" style="margin-left: auto; margin-right: auto; text-align: center">
                    <!--div( style="margin-left: 8vw; margin-right: 8vw" )-->
                    <div style="margin-left: auto; margin-right: auto; text-align: center">
                        <div class="hero-logo" style="margin-top: 10vh;"><img
                                src="../../../assets/CLS-DRisk/Group 1730@2x.png" alt="CLS logo" width="140" /></div>
                        <div style="display: flex;">
                            <div>
                                <h1 class="title section-title hero-title">Welcome to<br /><span>D-Risk</span></h1>
                                <p class="hero-subtitle" style="max-width: 542px;">Powerful land risk insight with
                                    future-proofed environmental risk appraisal for commercial real estate and financial
                                    institutions. Injecting expert opinion from acquisition through to divestment.</p>
                                <br /><button class="cls-btn hero-primary" type="button" (click)="scroll('sw')">OUR
                                    PRODUCTS</button>
                            </div>
                        </div>
                        <div class="overl-res d-none d-md-block"><img class="fadeOverlay" id="overlay"
                                src="./assets/CLS-DRisk/D-Risk-hero-section.png"
                                style="position: absolute; bottom: 60px; right: 0; z-index: 0; height: 33vh; width: 100vw;" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section></section>
<section style="padding-bottom: 60px; padding-top: 80px; min-height: 500px; background: #EDEFF2">
    <div style="text-align: center;">
        <h1 class="section-title" style="position: relative; top: 20px;">Our<span> Approach</span></h1>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12" style="text-align: center;">
                <p
                    style="margin-top: 60px; width: 50%; height: 80%; margin-left: auto; margin-right: auto; color: #6B7072; font-size: 16px">
                    Environmental risk solutions for commercial real estate professionals, property developers, and
                    financial institutions. <br /><br />We apply our expertise to the best spatial risk data and bespoke
                    insurance to support decision making and
                    investment.<br /><br />Our services help clients understand, assess, address and oversee
                    climate-related financial and development risks.</p>
            </div>
        </div>
    </div>
</section>
<section class="infographics-section" id="usp"
    style="margin-top: 0px;padding-top: 60px; margin-bottom: 30px;background: #ffffff; background-image: -webkit-linear-gradient(top, #e7e9e9 25%, #ffffff 100%);">
    <div class="container">
        <div class="row" style="text-align: center; color: #3d4d62; margin-left: auto; margin-right: auto;">
            <div class="col-12">
                <h1 class="section-title" style="margin-bottom: 50px; margin-top:30px; color: #034ea3;">Why we're<span
                        style="color: #34455A"> Different</span></h1>
            </div>
        </div>
        <div class="row"
            style="text-align: center; color: #3d4d62; margin-left: auto; margin-right: auto; margin-bottom: 70px; max-width:1250px;">
            <!--1-->
            <div class="col-xs-12 col-sm-12 col-md-6"
                style="padding-top: 25px; padding-bottom: 25px; padding-left: 25px; padding-right: 25px;"><img
                    class="img-fluid" src="./assets/CLS-DRisk/usps/Group 1727@2x.png" style="max-width: 60%" /></div>
            <!--2-->
            <div class="col-xs-12 col-sm-12 col-md-6"
                style="padding-top: 25px; padding-bottom: 25px; padding-left: 25px; padding-right: 25px;"><img
                    class="img-fluid" src="./assets/CLS-DRisk/usps/Group 1711@2x.png" style="max-width: 60%" /></div>
            <!--3-->
            <div class="col-xs-12 col-sm-12 col-md-6"
                style="padding-top: 25px; padding-bottom: 25px; padding-left: 25px; padding-right: 25px;"><img
                    class="img-fluid" src="./assets/CLS-DRisk/usps/Group 1713@2x.png" style="max-width: 60%" /></div>
            <!--4-->
            <div class="col-xs-12 col-sm-12 col-md-6"
                style="padding-top: 25px; padding-bottom: 25px; padding-left: 25px; padding-right: 25px;"><img
                    class="img-fluid" src="./assets/CLS-DRisk/usps/Group 1714@2x.png" style="max-width: 60%" /></div>
        </div>
    </div>
</section>
<section id="sw" style="padding-bottom: 60px; padding-top: 80px; min-height: 500px; background: #EDEFF2">
    <div style="text-align: center;">
        <h1 class="section-title" style="position: relative; top: 20px; color: #034ea3;">Our<span
                style="color: #34455A"> Products</span></h1>
    </div>
    <div class="container">
        <!-- tab selectors | tablet-->
        <div class="row text-center selectors">
            <div class="col-12" style="margin-bottom: 0;">
                <ul class="nav nav-tabs" style="margin-top: 60px; margin-left: auto; margin-right: auto">
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=0" [ngClass]="selectedSlice==0?'activeTab-link':''">D-Risk
                            Lending</a></li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=1" [ngClass]="selectedSlice==1?'activeTab-link':''">Climate-Related
                            Financial Risks</a></li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=2" [ngClass]="selectedSlice==2?'activeTab-link':''">Portfolio Risk
                            Assessment</a></li>
                </ul>
            </div>
        </div>
        <!-- bot selectors | mobile-->
        <div class="row text-center small-selectors" style="padding-top: 60px;">
            <div class="col-4"><button class="btn btn-circle primary-outline"
                    [ngClass]="{'btn-circle-selected':selectedSlice==0}" (click)=" selectedSlice = 0;"></button></div>
            <div class="col-4"><button class="btn btn-circle primary-outline"
                    [ngClass]="{'btn-circle-selected':selectedSlice==1}" (click)=" selectedSlice = 1"></button></div>
            <div class="col-4"><button class="btn btn-circle primary-outline"
                    [ngClass]="{'btn-circle-selected':selectedSlice==2}" (click)=" selectedSlice = 2"></button></div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-6 piecolumn">
                <div style="position: relative"><img src="../../../assets/CLS-DRisk/Group 1733@2x.png" alt="CLS logo"
                        width="80" style="position: absolute; top: 237px; left: 230px;" /></div>
                <div id="piechart" style="width: 100%; height: 100%;  width: 540px; height: 684px;"> </div>
            </div>
            <div class="col-md-12 col-lg-6 descriptioncolumn">
                <div style="margin-top: 60px;">
                    <div *ngIf="selectedSlice==0">
                        <h5><strong>D-Risk Lending</strong></h5>
                        <div class="activeTab" *ngIf="selectedTab=='expl'" id="explTab">
                            <p style="font-size: 14px; color: #6B7072">CLIMATE-AWARE ENVIRONMENTAL RISK
                                SCREENING<br />D-Risk Lending is a concise transaction screening report for valuers
                                acting in commercial mortgage lending and secured development finance combining the
                                latest authoritative environmental
                                risk datasets with leading expert advice.</p>
                            <p style="font-size: 14px; color: #6B7072">Developed in consultation with leading UK
                                lenders, D-Risk Lending is the first report of its kind to include climate-related
                                financial risks, enabling lenders to meet expectations on current and future
                                environmental risk management
                                and monitoring in accordance with the Prudential Regulation Authority's Supervisory
                                Statement SS3/19.</p><br />
                        </div>
                    </div>
                    <div *ngIf="selectedSlice==1">
                        <h5> <strong>Climate-Related Financial Risks </strong></h5>
                        <div class="activeTab" *ngIf="selectedTab=='expl'" id="explTab">
                            <p style="font-size: 14px; color: #6B7072">Mortgage book analysis specifically developed to
                                meet Prudential Regulation Authority expectations on the understanding, assessing,
                                addressing and oversight of climate-related financial risks. Delivered through a unique
                                industry
                                partnership with geospatial, property data and environmental perils modelling experts.
                            </p>
                        </div><br />
                    </div>
                    <div *ngIf="selectedSlice==2">
                        <h5> <strong>Portfolio Risk Assessment</strong></h5>
                        <p style="font-size: 14px; color: #6B7072">Environmental risk assessment of property portfolios
                            including site inspections and bespoke risk evaluation. This includes land contamination,
                            regulatory compliance, flood and ground stability hazards.</p>
                    </div>
                </div>
                <div style="margin-top: 10px">
                    <div style="display: inline"><img src="../../../assets/CLS-DRisk/Andrew@2x.png" width="170"
                            style="vertical-align: top; border: 6px solid #024693; border-radius: 100px" /></div>
                    <div style="display: inline-block; margin-left: 25px;">
                        <p style="padding-top: 15px; font-size: 14px; color: #6B7072">Andrew Pullman</p><a
                            href="mailto:andrew.pullman@d-riskgroup.com">Andrew.Pullman@d-riskgroup.com </a><br /><a
                            href="callto:07852972703">+44(0) 7852 972703</a><br />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div style="text-align: center; margin-top: 80px; margin-bottom: 80px">
                    <h1 class="section-title">Working <span style="color: #034ea3">With</span></h1><br />
                </div>
                <div style="margin-top: 60px; margin-bottom: 100px; text-align: center;">
                    <img src="../../../assets/working-with-logos/Airbus.png" width="270" style="margin: 36px" />
                    <img src="../../../assets/working-with-logos/fci.png" width="120" style="margin: 36px" />
                    <img src="../../../assets/working-with-logos/When.png" width="260" style="margin: 36px" />
                    <img src="../../../assets/working-with-logos/ashfield.jpg" width="270" style="margin: 36px" />
                </div>
            </div>
        </div>
    </div>
</section>
<section style="background: #f2f5f5; padding-bottom:50px;">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div style="text-align: center; margin-top: 80px">
                    <h1 class="section-title">Key<span style="color: #034ea3"> Contacts </span></h1><br />
                </div>
                <team-carousel [members]="_teamMembers" [showControls]="true"
                    style="margin-left: auto; margin-right: auto; text-align: center;"></team-carousel>
            </div>
        </div>
    </div>
</section>